export default {
  rowsPerPageOptions: [5, 10, 25, 50, 100, 500, 1000, 10000],
};
